import { Button } from 'antd';
import styled from 'styled-components';

export const StyledIconsWrapper = styled.span`
    font-size: 16px;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    svg {
        color: var(--brand-6);

        &:hover {
            color: var(--brand-5);
            cursor: pointer;
        }
    }
`;

export const StyledFileButton = styled(Button)`
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: transparent;
    }

    &:disabled {
        background-color: transparent;
        border-color: transparent;

        svg {
            color: var(--gray-6);
        }
    }
`;
